import { CALL_API } from '../../middleware/api';
import * as ActionTypes from '../BigStakeRequest';
function fetchCancelBigStakeRequest(data) {
    var _a;
    var gamblerId = data.gamblerId, stakeId = data.stakeId;
    return _a = {
            type: ActionTypes.QUICKBET_CANCEL_BIG_STAKE_REQUEST
        },
        _a[CALL_API] = {
            endpoint: "/bet/stake-request/".concat(stakeId, "/").concat(gamblerId, "/cancel"),
            method: 'post',
            types: [ActionTypes.QUICKBET_SUCCESS_BIG_STAKE_REQUEST_CANCEL, ActionTypes.QUICKBET_FAILURE_BIG_STAKE_REQUEST_CANCEL],
            credentials: true,
            data: data
        },
        _a;
}
export function cancelBigStakeRequest(data) {
    return function (dispatch) {
        return dispatch(fetchCancelBigStakeRequest(data));
    };
}
function fetchCancelBigStakeBetSlip(data) {
    var _a;
    var gamblerId = data.gamblerId, stakeId = data.stakeId;
    return _a = {
            type: ActionTypes.CANCEL_BIG_STAKE_REQUEST
        },
        _a[CALL_API] = {
            endpoint: "/bet/stake-request/".concat(stakeId, "/").concat(gamblerId, "/cancel"),
            method: 'post',
            types: [ActionTypes.SUCCESS_BIG_STAKE_REQUEST_CANCEL, ActionTypes.FAILURE_BIG_STAKE_REQUEST_CANCEL],
            credentials: true,
            data: data
        },
        _a;
}
export function cancelBigStakeBetSlip(data) {
    return function (dispatch) {
        return dispatch(fetchCancelBigStakeBetSlip(data));
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/BigStakeRequest.js